import { TextBox } from '@progress/kendo-react-inputs';
import { useSettingStringValue } from '../../../../home/hooks/settings';
import { useSearchContext } from '../../../context/SettingsSearchContext';
import { SettingsElementType } from '../types';
import MarkerText from '../../../../../components/inputs/MarkerText';

export default function SettingsTextElement(props: { element: SettingsElementType & { type: 'text-input' } }) {
    const context = useSearchContext();
    const hook = useSettingStringValue(props.element.value);

    return (
        <div className="d-flex justify-content-between align-items-center px-3">
            <div>
                <MarkerText highlight={context.term}>{props.element.name}</MarkerText>
                <div>
                    <MarkerText highlight={context.term} className="secondary-text">
                        {props.element.hint}
                    </MarkerText>
                </div>
            </div>
            <div className="flex-shrink-0 flex-grow-0 d-flex flex-column justify-content-center" style={{ width: 300, minHeight: 55 }}>
                <TextBox value={hook.value ?? ''} onChange={hook.onChange} placeholder={props.element.placeholder} />
            </div>
        </div>
    );
}
